'use client'

import {
  Button,
  FilterInputs,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useTableState,
} from '@repo/ui/components'
import { Filter } from 'lucide-react'
import { useMemo } from 'react'

export const TableFilters = <TData,>() => {
  const { table } = useTableState<TData>()

  const headers = table.getFlatHeaders() ?? []

  const isEmpty = useMemo(() => {
    if (!headers.length) return true

    return headers.filter(header => header.column.getCanFilter()).length === 0
  }, [headers])

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button className={'max-md:size-10'} disabled={isEmpty} variant={'outline'}>
          <Filter /> <span className={'max-md:hidden'}>Filters</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        {headers.map(
          header =>
            header.column.getCanFilter() && (
              <div className={'flex w-full items-center gap-2'} key={header.id}>
                <label>{header.column.columnDef.header as string}</label>
                <FilterInputs column={header.column} />
              </div>
            ),
        )}
      </PopoverContent>
    </Popover>
  )
}
